/* @flow */
import API from 'lib/RemindAPI';

/* Retrieve the computed fee from the API
 * @param amount integer - value in cents.
 */
// $FlowFixMe
export function fetchFeeForAmount(amount: number): Promise {
  return API.request('/payments/fees', 'GET', { amount }).then(
    response => response.fee
  );
}



// WEBPACK FOOTER //
// ./src/lib/fee.js